module.exports = __webpack_public_path__ + "assets/img/ps-5-light.88d1f489.png";